import { PageLayout, useBrowserTitle } from '@acp/core-ui';
import React, { Suspense } from 'react';
import { useAgencySettings, useExperiment, useSession } from '@acp/feature/auth';
import { StateShortName } from '@acp/shared';
import { NotFoundPage } from './not-found';
import {
    MinimumStandardsMarketingPage,
} from '../features/minimum-standards/marketing-page';

const MinimumStandardsPage = React.lazy(() => import('../features/minimum-standards/page'));

export function MinimumStandards() {
    useBrowserTitle('Minimum Standards');

    const { isLoading } = useExperiment();
    const { complianceAgencyState } = useSession();
    const { agencySettings, isLoading: isAgencySettingsLoading } = useAgencySettings();

    const isVic = complianceAgencyState.toLocaleLowerCase() === StateShortName.VIC;
    const isEnrolled = agencySettings?.hasAgreedToMinimumStandardsAssessments === true;

    if (isLoading || isAgencySettingsLoading) {
        return <MinimumStandardsMarketingPage.Skeleton />;
    }

    if (!isVic) return <NotFoundPage />;

    return (
        <Suspense fallback={<PageLayout.Skeleton sidebar aside controls />}>
            {isEnrolled ? <MinimumStandardsPage /> : <MinimumStandardsMarketingPage />}
        </Suspense>
    );
}
